'use client';

import { cn } from '@/lib';
import { safeHtmlListParserOptions } from '@/utils/safeHtmlParserOptions';
import parse from 'html-react-parser';
import { useState } from 'react';
interface AboutEventProps {
  description: string;
}

const AboutEvent = ({ description }: AboutEventProps) => {
  const [readMore, setReadMore] = useState(false);

  if (!description) return null;

  // Rendered on the server too (no hydration gate) so search engines can
  // read the full event description — it's our primary body content.
  const isTruncated = description.length > 250;
  const shouldClamp = !readMore && isTruncated;

  return (
    <div className="flex flex-col gap-2">
      <h2 className="text-xl font-bold text-gray-900">About the Event</h2>

      {description && (
        <div className="font-medium text-zinc-600 text-sm flex flex-col gap-2 w-full min-w-0">
          <div className={cn(
            "[&>ul]:list-disc [&>ul]:pl-5 [&>ol]:list-decimal [&>ol]:pl-5 text-wrap w-full break-words",
            shouldClamp && 'sm:line-clamp-3 line-clamp-5 test-sm'
          )}>
            {parse(description, safeHtmlListParserOptions)}
          </div>
          {isTruncated && (
            <span
              onClick={() => setReadMore(prev => !prev)}
              className="cursor-pointer text-xs text-[#fd4949] hover:underline"
            >
              {readMore ? 'Show Less' : 'Show More'}
            </span>
          )}
        </div>
      )}
    </div>
  );
}

export default AboutEvent;
